import { Button, DialogActions, DialogContentText } from '@material-ui/core';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import styles from './ConfirmationComponent.module.scss';

const Confirmation = ({
	open,
	handleClose,
	title,
	dialogContent,
	buttonList,
	styledConfirmation,
}) => {
	if (styledConfirmation) {
		return (
			<Dialog
				maxWidth={'sm'}
				fullWidth
				open={open}
				onClose={handleClose}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				className={styles.dialogWrapper}
			>
				<DialogTitle
					id='alert-dialog-title'
					className={styles.styledTitle}
				>
					{title}
				</DialogTitle>
				<DialogContent className={styles.styledContent}>
					<DialogContentText id='alert-dialog-description'>
						{dialogContent}
					</DialogContentText>
				</DialogContent>
				<DialogActions
					style={{
						justifyContent: 'center',
					}}
				>
					{buttonList?.map((button) => {
						return (
							<Button
								onClick={button.action}
								style={button.style}
							>
								{button.name}
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		);
	} else
		return (
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'
				className={styles.dialogWrapper}
			>
				<DialogTitle
					id='alert-dialog-title'
					className={styles.dialogTitle}
				>
					{title}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id='alert-dialog-description'>
						{dialogContent}
					</DialogContentText>
				</DialogContent>
				<DialogActions
					style={{
						justifyContent: 'center',
					}}
				>
					{buttonList?.map((button) => {
						return (
							<Button
								onClick={button.action}
								style={button.style}
							>
								{button.name}
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		);
};

export default Confirmation;
